<template>
<el-row class="cs-contentContainer">
    <el-col :span="4" class="cs-main-left-container">
        <navigator></navigator>
    </el-col>
    <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div style="" class="cs-fullHeight cs-contentContainer-right">
            <div class="backgroud-white cs-fullHeight">
                <el-row>
                    <el-col :span="12" style="margin-left:50px;margin-top:50px">
                        <h3>第一步：登记在校课程数量</h3>
                        <div class="backgroud-red" style="margin-top:20px;">
                            <label style="margin: 10px 10px 10px 20px">为了能帮助所有速成学员更合理的安排上课时间，请仔细对照学校的课程表并填入准确信息</label>
                        </div>
                        <div style="height:50px;">&nbsp;</div>
                        <h6>本学期您在学校一共拿了几门课？</h6>
                        <el-form :model="courseForm" :rules="rules" ref="courseForm">
                            <div style="width: 250px">
                                <el-form-item prop="Total">
                                    <el-select v-model="courseForm.Total" @change="checkAllInputs" placeholder="请选择课程数量">
                                        <el-option v-for="item in courseCountList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <el-form-item>
                                <div style="margin-top:50px;">
                                    <el-button ref="nextButton" v-bind:type="btnClass" :disabled="disabledFlag" @click="nextStep">下一步</el-button>
                                </div>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
            </div>
        </div>
    </el-col>
</el-row>
</template>

<script>
import navigator from "../components/navigator";
import {
    getStore,
    setStore
} from "../config/mUtils";
import {
    saveCourseCount,
    getStudentCourseCount
} from "../service/course.service";
export default {
    data() { 
        return {
            disabledFlag: false,
            btnClass: "info",
            courseForm: {
                Id: "",
                TermId: "",
                StudentId: "",
                Total: "",
                SheduledCourseCount: ""
            },
            rules: {
                Total: [{
                    required: true,
                    message: "请选择课程数量",
                    trigger: "blur"
                }]
            },
            courseCountList:[]
        };
    },
    created() {
        let universityAbbreviation = getStore("user_student_universityAbbreviation");
        if (!!universityAbbreviation && universityAbbreviation.indexOf("UTM") >= 0){
            this.courseCountList = [
                {label:"1",value:1},
                {label:"2",value:2},
                {label:"3",value:3},
                {label:"4",value:4},
                {label:"5",value:5},
                {label:"6",value:6},
            ];
        }else{
               this.courseCountList = [
                {label:"1",value:1},
                {label:"2",value:2},
                {label:"3",value:3},
                {label:"4",value:4},
                {label:"5",value:5},
                {label:"6",value:6},
            ];
        }
        getStudentCourseCount(getStore("user_student_id")).then(result => {
            if (!!result && result.success) {
                this.courseForm.Id = result.data.Id;
                this.courseForm.TermId = result.data.TermId;
                this.courseForm.StudentId = result.data.StudentId;
                this.courseForm.Total =
                    result.data.Total == 0 ? "" : result.data.Total.toString();
                this.courseForm.SheduledCourseCount = result.data.SheduledCourseCount;
                //this.courseForm.UniversityName = result.data.model.universityName;
                if (!this.courseForm.Total) {
                    this.btnClass = "info";
                    this.disabledFlag = true;
                } else {
                    this.btnClass = "primary";
                    this.disabledFlag = false;
                }
            }
        });
    },
    components: {
        navigator
    },
    methods: {
        async nextStep() {
            this.$data.disabledFlag = true;
            if (!!this.$refs["courseForm"]) {
                let isValid = true;
                this.$refs["courseForm"].validate(valid => {
                    if (valid) {} else {
                        isValid = false;
                    }
                });
                if (!isValid) {
                    return false;
                }
                let studentId = getStore("user_student_id");
                this.courseForm.StudentId = studentId;
                let result = await saveCourseCount(this.courseForm);
                if (result) {
                    if (!result.success) {
                        this.errorMessage = result.message;
                        //this.showError = true;
                        this.$message({
                            message: result.message,
                            type: "warning"
                        });
                    } else {
                        this.$data.courseForm.Id = result.data.Id;
                        setStore("user_student_hasStudentCourseNumber", 1);
                        this.$router.push("/courseSchedule");
                    }
                    this.$data.disabledFlag = false;
                }
            }
        },
        checkAllInputs() {
            if (!!this.courseForm.Total) {
                this.btnClass = "primary";
                this.disabledFlag = false;
            } else {
                this.btnClass = "info";
                this.disabledFlag = true;
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/page/courseCount.vue